import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SkeletonLoading } from "../../../Component/Common/SkeletonLoading/SkeletonLoading";
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { EntriesPerPage, IBulkActions } from "../../../Component/Model/Table/Table";
import { VAContactTable } from "./ContactTableMapper";

interface IVAContactData {
    results: VAContactTable;
    entriesPerPage: EntriesPerPage;
    pageNumber: number;
    filteredItemsCount: number;
    totalItemsCount: number;
    entriesPerPageChanged: (entriesPerPage: number) => void;
    pageNumberChanged: (pageNumber: number) => void;
    searchValueChanged: (searchValue: string) => void;
    bulkActions: IBulkActions[];
    isLoading: boolean;
    columnSortingChanged: (sortOption: ColumnSortOption) => void;
    isButtonOutlined?: boolean;
}


export const VerificationAgencyContactTable = (props: IVAContactData) => {
    

    if (props.results !== undefined) {
        return (
            <>
                <DataTable
                    key={props.filteredItemsCount}
                    table={props.results}
                    canSearch
                    entriesPerPage={props.entriesPerPage}
                    pageNumber={props.pageNumber}
                    filteredItemsCount={props.filteredItemsCount}
                    totalItemsCount={props.totalItemsCount}
                    entriesPerPageChanged={props.entriesPerPageChanged}
                    pageNumberChanged={props.pageNumberChanged}
                    searchValueChanged={props.searchValueChanged}
                    isLoading={props.isLoading}
                    bulkActions={props.bulkActions}
                    manualSorting={false}
                    columnSortingChanged={props.columnSortingChanged}
                    isButtonOutlined ={props.isButtonOutlined}
                ></DataTable>
            </>
        )
    } else {
        //This means the table is loading
        return (
            <SkeletonLoading tableLoading/>
        )
    }

}

